/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-guest': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(6 6)" _fill="#FFF" fill-rule="nonzero"><path pid="0" d="M5.914 12.746a11.06 11.06 0 00-4.582 1.924 1.91 1.91 0 00-.75 1.533v2.41A.387.387 0 00.969 19h17.062a.387.387 0 00.387-.388v-2.409a1.91 1.91 0 00-.75-1.533 11.06 11.06 0 00-4.582-1.924.382.382 0 00-.371.135c-.09.107-.944 2.24-3.215 2.24-2.202 0-3.147-2.16-3.214-2.24a.39.39 0 00-.372-.135z"/><path pid="1" d="M11.503 12.02a5.434 5.434 0 003.425-5.04V5.427a5.428 5.428 0 10-10.856 0V6.98a5.42 5.42 0 007.43 5.042zM5.62 6.98V5.62a.194.194 0 01.194-.193h.582c.996 0 3.015.245 4.512-1.387a.192.192 0 01.286 0 4.1 4.1 0 002.058 1.222.17.17 0 01.128.163v1.554a3.88 3.88 0 01-7.759 0h-.001z"/><circle pid="2" cx="11.051" cy="7.173" r="1"/><circle pid="3" cx="7.949" cy="7.173" r="1"/><path pid="4" d="M9.563 9.98c.227.001.453-.032.67-.097.117-.035.23-.082.338-.14a.496.496 0 00-.237-.932H8.788a.496.496 0 00-.238.933c.107.057.22.104.337.14.218.065.445.098.672.097h.004z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-guest.js